import { Component } from '@angular/core';
import { TipoUsuario } from '@shared/enums/tipoUsuario';
import { AuthService } from '@authentication/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-facturacion-index',
  templateUrl: './facturacion-index.component.html',
  styleUrls: ['./facturacion-index.component.css']
})
export class FacturacionIndexComponent {
  TipoUsuario = TipoUsuario;

  constructor(
    private authService: AuthService, 
    private router: Router) { }

  hasRole(...roles: TipoUsuario[]) {
    return this.authService.hasRole(...roles);
  }
}
